import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import { PHONE_STATUS } from "../common";
import { PaymentFooter } from "../payment.process/payment.process";

const CardError = ({ onClose }: { onClose: () => void; }) => {
    const { state, update } = usePaymnetContext();
    const { t } = useTranslation();
    const isInvalidPin = state.phoneStatus === PHONE_STATUS.INVALID_PIN;

    const SUBMIT_BTN = {
        [PHONE_STATUS.PHONE_REQUIRED]: t("phoneNumberProceed"),
        [PHONE_STATUS.PHONE_NOT_REGISTER]: t("changeNumber"),
        [PHONE_STATUS.INVALID_PIN]: t("pinChange"),
        [PHONE_STATUS.PHONE_VERIFY]: t("confirm"),
        [PHONE_STATUS.CONFIRMATION_INPROGERSS]: t("confirm"),
    }

    const submit = () => {
        if (isInvalidPin) {
            update({ ...state, phoneStatus: PHONE_STATUS.PHONE_VERIFY })
        } else {
            update({ ...state, phone: { ...state.phone, error: "" }, phoneStatus: PHONE_STATUS.PHONE_REQUIRED })
        }
    }

    return <>
        <div className="unregistered-phone">
            <div className="phone">
                <span>{state.phone.value}</span>
                {isInvalidPin && <div className="circle">
                    <div className="checkmark"></div>
                </div>}
            </div>
            <div className="validaiton-wrapper">
                <img className="icon" src="https://pg-vnext-banners.s3.eu-central-1.amazonaws.com/vnext-images/pgvnext-payment-images/warning.svg" alt="not registred" />
                <div className="message">
                    <b className="title">{isInvalidPin ? t("unregisterdPINTitle") : t("unregisterdNumTitle")}</b>
                    <div>{isInvalidPin ? state.pin.error : t("unregisterdNumMsg")}</div>
                </div>
            </div>
        </div>
        <PaymentFooter submitTxt={SUBMIT_BTN[state.phoneStatus]} onClose={onClose} onSubmit={submit} />
    </>
}

export default CardError
